module.exports = function() {
  return new Worker(__webpack_public_path__ + "408640b310e403735156.worker.js");
};